import type { RelatedApp } from '@wix/add-panel-common';

const getWeight = (categoryNum: string, app: RelatedApp) => (app.weights ? -app.weights.categories[categoryNum] : 0);

export const getSortedCategoryApps = (
  relatedApps: RelatedApp[],
  categoryRelatedAppId?: string,
  tagId?: string,
): RelatedApp[] => {
  const categoryRelatedApps = relatedApps.filter((app) => {
    if (app.categories && categoryRelatedAppId) {
      return app.categories.includes(categoryRelatedAppId);
    } else if (tagId) {
      return typeof app.tagsOrder?.[tagId] === 'number';
    }
    return false;
  });
  if (tagId && relatedApps[0]?.tagsOrder) {
    categoryRelatedApps.sort((app1, app2) => app1.tagsOrder[tagId] - app2.tagsOrder[tagId]);
  } else if (categoryRelatedAppId) {
    return categoryRelatedApps.sort(
      (app1, app2) => getWeight(categoryRelatedAppId, app1) - getWeight(categoryRelatedAppId, app2),
    );
  }
  return categoryRelatedApps;
};
